<style type="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <div class="container" :style="styles">
            <EchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'></EchartBmap>
        </div>
    </div>
</template>

<script>
    import EchartBmap from './../echartBmap';
    import mapPropsMinxin from './map-props-minxin';
    export default {
        name: '',
        props: {},
        mixins: [mapPropsMinxin],
        components: {
            EchartBmap
        },
        data() {
            return {
                width: null,
                height: null
            }
        },
        watch: {
            lng() {
                this.$nextTick(() => {
                    this.$refs.map && this.setCenter();
                })
            },
            lat() {
                this.$nextTick(() => {
                    this.$refs.map && this.setCenter();
                })
            },

            //鼠标放大
            mouseZoom() {
                this.setMouseZoom();
            },
            //地图拖拽
            drag() {
                this.setDrag();
            },
            zoom() {
                this.$nextTick(() => {
                    this.$refs.map && this.setZoom();
                })
            },
            zoomMax() {
                this.setMapZoomMax();
            },
            zoomMin() {
                this.setMapZoomMin();
            },
            //工具条
            zoomTool() {
                this.setZoomTool();
            },
            mapStyle() {
                this.$nextTick(() => {
                    this.$refs.map && this.setMapstyle();
                })
            },
            scale() {
                this.$nextTick(() => {
                    if (this.$refs.map) {
                        this.$refs.map.create();
                    }
                });
            },
            showMap() {
                this.$nextTick(() => {
                    this.$refs.map && this.setMapShowOrHidn();
                })
            },


        },
        computed: {
            styles() {
                const scale = Math.abs(2 - this.scale);
                return {
                    'width': this.width == null ? '100%' : `${this.width*this.scale}px`,
                    'height': this.height == null ? '100%' : `${this.height*this.scale}px`,
                    'transform': `scale(${scale},${scale})`,
                    'transform-origin': `0px 0px`
                }

            }
        },
        methods: {
            setCenter() {
                const mapComponent = this.$refs.map;
                mapComponent.setCenter(this.lng, this.lat);
            },
            setCenterAndZoom() {
                const mapComponent = this.$refs.map;
                mapComponent.centerAndZoom(this.lng, this.lat, this.zoom);
            },
            setZoom() {
                const mapComponent = this.$refs.map;
                mapComponent.setZoom(this.zoom);
            },
            setZoomTool() {
                const mapComponent = this.$refs.map;

                mapComponent.setZoomConfig({
                    show: this.zoomTool,
                });
            },
            setMapZoomMax() {
                const mapComponent = this.$refs.map;
                mapComponent.setZoomConfig({
                    max: this.zoomMax,
                });
            },
            setMapZoomMin() {
                const mapComponent = this.$refs.map;
                mapComponent.setZoomConfig({
                    min: this.zoomMin,
                });
            },

            setMouseZoom() {
                const map = this.$refs.map.getMap();
                if(map==null) return;
                if (this.mouseZoom) {
                    map.enableScrollWheelZoom();
                } else {
                    map.disableScrollWheelZoom();
                }

            },
            setDrag() {
                const map = this.$refs.map.getMap();
                  if(map==null) return;
                if (this.drag) {
                    map.enableDragging();
                } else {
                    map.disableDragging();
                }
            },
            setMapstyle() {
                const mapComponent = this.$refs.map;
                mapComponent.setStyle(this.mapStyle);
            },
            setMapShowOrHidn() {
                const mapComponent = this.$refs.map;
                if (this.showMap) {
                    mapComponent.show();
                } else {
                    mapComponent.hide();
                }
            },

            mapLoad() {
                const mapComponent = this.$refs.map;
                this.setMapstyle();
                this.setCenterAndZoom();
                this.setMapShowOrHidn();
                this.setZoomTool();
                this.setMouseZoom();
                this.setMapZoomMax();
                this.setMapZoomMin();
                this.setDrag();
                this.$emit('map-load');
            },
            getMapComponent() {
                return this.$refs.map;
            },
            resize() {
                const myMapComponent = this.getMapComponent();
                const myEcharts = myMapComponent.getEcharts();
                const containerDom = this.$el.parentNode;
                this.width = containerDom.offsetWidth;
                this.height = containerDom.offsetHeight;
                myEcharts.resize({
                    width: this.width,
                    height: this.height
                });
                setTimeout(() => {
                    myMapComponent.setCenter(this.lng, this.lat, true);
                }, 100);

            }
        },
        mounted() {
            this.width = this.$el.offsetWidth;
            this.height = this.$el.offsetHeight;
        }
    }
</script>